import React, { useState, useEffect, useContext } from 'react';
import {

  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  Backdrop,
  TextField,
  TableFooter,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Alert,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MUIDataTable from 'mui-datatables';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { useNavigate, Link } from 'react-router-dom';
import Scrollbar from 'src/components/scrollbar';
import Iconify from '../../../iconify';
import Icon from 'src/components/color-utils/Icon';
import { toast } from 'react-hot-toast';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { CalculateBillableCosts } from 'src/components/customecomponent/CalculateBillableCosts';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { AuthContext } from 'src/context/AuthContext';
import TaskCompletionModal from 'src/components/SharedComponent/Tasks/TaskCompletionModal';

// mock
const { PRIVATE_ROUTE } = API_ROUTES;

export default function ManagersideTasklist() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const { authAxios } = useContext(FetchContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const [selectedstartDate, setselectstartDate] = useState(null);
  const [selectendDate, setselectendDate] = useState(null);
  const [estimatedCost, setEstimatedCost] = useState(0);
  const [dwrCost, setDwrCost] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [pendingDuplicate, setPendingDuplicate] = useState(null);
  const [manageId, setManageId] = useState('All_Manager');
  const { state } = useContext(AuthContext);
  const [completionDialogOpen, setCompletionDialogOpen] = useState(false);
  const [completionIssues, setCompletionIssues] = useState([]);
  const [completionError, setCompletionError] = useState('');
  const [completionTaskId, setCompletionTaskId] = useState(null);
  const [completionCanComplete, setCompletionCanComplete] = useState(false);
  const [completingTask, setCompletingTask] = useState(false);
  const [completionJobNumber, setCompletionJobNumber] = useState('');
  const [completionTaskNumber, setCompletionTaskNumber] = useState('');

  const navigate = useNavigate();

  const handleEditRedirect = (e, id) => {
    navigate(`/manager/task/update/${id}`);
  };

  const handleRowDelete = async (e, id) => {
    if (confirm('Are you sure want to delete?') === true) {
      try {
        const deleteData = await authAxios.post(
          `${PRIVATE_ROUTE?.DELETE_TASK}${id}`
        );

        if (deleteData?.data?.statusCode === 400) {
          return toast.error(deleteData.data.message);
        }

        // Refresh task list
        await getTaskdata({
          sortField: sortEnable.sortField,
          sortOrder: sortEnable.sortOrder,
          searchQuery: searchEnable,
          page_no: page,
        });

        // Refresh Estimated Cost
        await getEstimatedBillableCost({
          managerId: manageId,
          startDate: selectedstartDate,
          endDate: selectendDate,
        });

        toast.success('Task deleted successfully');
      } catch (error) {
        console.error('Error deleting task:', error);
        toast.error('Failed to delete task');
      }
    }
  };

  useEffect(() => {
    getEstimatedBillableCost({
      managerId: 'All_Manager',
      startDate: '',
      endDate: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEstimatedBillableCost = async ({
    managerId = manageId,
    startDate = selectedstartDate,
    endDate = selectendDate,
  } = {}) => {
    try {
      const params = new URLSearchParams({
        is_complete: '0',
        user_id: managerId,
        startDate: startDate || '',
        endDate: endDate || '',
      });

      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE.GET_TASK_TOTAL_ESTIMATED_HOURS}?${params.toString()}`
      );

      setDwrCost(parseFloat(data.totalBillableCost || 0));
      setEstimatedCost(parseFloat(data.totalEstimatedCost || 0));
    } catch (error) {
      console.error('Error fetching task totals:', error);
      setDwrCost(0);
      setEstimatedCost(0);
    }
  };

  const handlejobcreateform = () => {
    navigate('/manager/task/create');
  };
  const getTaskdata = (query) => {
    let sort_params;
    const page_cout = query.page_no ? query.page_no : 0;

    // Use the manager passed in the query.
    // If not provided, use the currently selected manager.
    const selectedManagerId = query.manageId || manageId;

    const start_date =
      query.startDate !== undefined
        ? query.startDate
        : selectedstartDate !== null
          ? selectedstartDate
          : '';

    const end_date =
      query.endDate !== undefined
        ? query.endDate
        : selectendDate !== null
          ? selectendDate
          : '';
    let search_query = query.searchQuery ? encodeURIComponent(query.searchQuery) : '';

    if (typeof query !== 'string') {
      sort_params = `&startDate=${start_date}&endDate=${end_date}&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}&startDate=${start_date}&endDate=${end_date}`;
    }

    let isMounted = true;

    const getTasks = async () => {
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE?.GET_TASK}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}&is_complete=0&user_id=${selectedManagerId}`
      );

      if (isMounted) {
        setTasks(
          data?.data?.map((item) => {
            const totalOfDwrCost = CalculateBillableCosts(item);
            const totalBilebleSum = totalOfDwrCost.reduce(
              (acc, curr) => acc + curr.totalCost,
              0
            );

            const project_managers_name = item.project_managers.map(
              (pmdetails) =>
                pmdetails.first_name + ' ' + pmdetails.last_name
            );

            return {
              _id: item._id,
              name: item.name,
              task_number: (
                <Link to={`/manager/task/view/${item._id}`}>
                  <b>{item.number_str}</b>
                </Link>
              ),
              job_number: (
                <Link to={`/manager/job/view/${item.job_id._id}`}>
                  <b>{item.job_id.number_str}</b>
                </Link>
              ),
              client_number: (
                <Link to={`/manager/client/view/${item.client_id._id}`}>
                  <b>{item.client_id.company_name}</b>
                </Link>
              ),
              quote_number: (
                <Link to={`/manager/quote/view/${item?.quote_id?._id}`}>
                  <b>{item?.quote_id?.number_str}</b>
                </Link>
              ),
              task_scope: item?.task_scope_id?.name,
              estimated_cost: item.total_cost_hour,
              dwrs_hours_cost: totalBilebleSum,
              ratesheet: item.ratesheet_id.name,
              status: item.status_id.name,
              manager: project_managers_name.join(', '),
              active: (
                <Icon
                  color={item.active === true ? 'green' : 'red'}
                  name="people"
                  size={30}
                />
              ),
              complete_task: renderActionButton(item),
              job_number_str: item?.job_id?.number_str,
              client_id: item.client_id._id,
            };
          })
        );

        setCount(data.total);
        setLoading(false);
      }
    };

    getTasks().catch((err) => {
      if (!isMounted) return;

      console.error('failed to fetch data', err);
      setLoading(false);
    });

    return () => {
      isMounted = false;
    };
  };

  const handleAction = async (event, taskData) => {
    event.preventDefault();

    const taskId = taskData._id;

    try {
      setLoading(true);
      setCompletionTaskId(taskId);
      setCompletionJobNumber(taskData?.job_id?.number_str || '');
      setCompletionTaskNumber(taskData?.number_str || '');
      setCompletionError('');
      setCompletionIssues([]);
      setCompletionCanComplete(false);

      const { data } = await authAxios.get(
        PRIVATE_ROUTE.GET_TASK_COMPLETION_CHECK.replace(
          ':task_id',
          taskId
        )
      );

      setCompletionIssues(data?.unresolved || []);
      setCompletionCanComplete(Boolean(data?.can_complete));

      if (!data?.can_complete) {
        setCompletionError(
          data?.message ||
          'This task cannot be completed until all outstanding Schedule/Todo Draft items are resolved.'
        );
      }

      setCompletionDialogOpen(true);
    } catch (error) {
      console.error('Error validating task completion:', error);

      const responseData = error?.response?.data;

      setCompletionIssues(responseData?.unresolved || []);
      setCompletionCanComplete(false);
      setCompletionError(
        responseData?.message ||
        'Failed to validate task completion. Please try again.'
      );
      setCompletionDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleTaskComplete = async (taskId) => {
    if (!taskId) return;

    try {
      setCompletingTask(true);

      const payload = {
        task_complete_date: dayjs().format('YYYY-MM-DD'),
        status: 'complete',
      };

      await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TASK_STATUS}${taskId}`,
        payload
      );

      setCompletionDialogOpen(false);
      toast.success('Task completed successfully');

      await getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    } catch (error) {
      console.error('Error completing task:', error);

      toast.error(
        error?.response?.data?.message ||
        'Failed to complete the task. Please try again.'
      );
    } finally {
      setCompletingTask(false);
    }
  };

  // then define renderActionButton
  const renderActionButton = (taskData) => {
    let showButton = false;

    if (taskData?.dwrs && taskData.dwrs.length > 0) {
      showButton = taskData.dwrs.every((dwr) => dwr.status && dwr.status !== 0);
    }

    if (showButton && !taskData.is_completed) {
      return (
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => handleAction(e, taskData)}
        >
          Complete Task
        </Button>
      );
    }

    return <Typography>-</Typography>;
  };

  function handleDateSort() {
    if (selectendDate !== null && selectedstartDate !== null) {
      setLoading(true);

      // Refresh task list using selected dates
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: 0,
        manageId: manageId,
      });

      // Refresh total estimated/billable cost using selected dates
      getEstimatedBillableCost({
        managerId: manageId,
        startDate: selectedstartDate,
        endDate: selectendDate,
      });
    }
  }


  function handleClearDateSort() {
    setselectendDate(null);
    setselectstartDate(null);
    setManageId('All_Manager');
    setPage(0);
    setLoading(true);

    getEstimatedBillableCost({
      managerId: 'All_Manager',
      startDate: '',
      endDate: '',
    });

    getTaskdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: 0,
      manageId: 'All_Manager',
      startDate: '',
      endDate: '',
    });
  }


  useEffect(() => {
    if (rowsPerPage * page < count) {
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    } else {
      getTaskdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
    setLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  const columns = [
    {
      name: '_id',
      label: 'Id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'task_number',
      label: 'Task Number',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: `job_number`,
      label: 'Job Number',
      options: {
        draggable: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'client_number',
      label: 'Client',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: true,
        filter: true,
        display: true,
      },
    },
    {
      name: 'ratesheet',
      label: 'RateSheet',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'estimated_cost',
      label: 'Estimated Cost',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'dwrs_hours_cost',
      label: 'Dwrs Hours Cost',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_scope',
      label: 'Task Scope',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'complete_task',
      label: 'Complete Task',
      options: {
        draggable: false,
        filter: false,
        sort: false,
        display: true,
      },
    },
    {
      name: '',
      lable: 'Action',
      options: {
        filter: true,
        display: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const { rowIndex } = tableMeta;
          const rowData = tasks[rowIndex];
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <ContentCopyIcon // <- Material UI copy/duplicate icon
                style={{ cursor: 'pointer' }}
                onClick={(e) => handleDuplicate(e, rowData._id, rowData.client_id, rowData.job_number_str)}
              />
              <EditIcon onClick={(e) => handleEditRedirect(e, tableMeta.rowData[0])} />
              <DeleteIcon onClick={(e) => handleRowDelete(e, tableMeta.rowData[0])} />
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standerd',
    print: true,
    filter: false,
    fixedHeader: true,
    searchOpen: true,
    count: count,
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];

          item.data.forEach((el) => {
            if (typeof el !== 'object') {
              result.push(el);
            }

            if (typeof el === 'object') {
              if (el.props?.to) {
                result.push(el.props.children.props.children);
              }

              if (Array.isArray(el.props?.children)) {
                const childrenArray = el.props.children;

                const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
                result.push(combinedString);

              }
            }
          });

          return result;
        }

        return null;
      });
      const result = formattedData.map((data, index) => ({
        index: index,
        data: data,
      }));
      const footerData = ['', '', '', 'Total : ', `${estimatedCost}`, `${dwrCost}`];

      return `${buildHead(columns)}${buildBody(result)}\n${footerData.join(',')}\n`;
    },
    setRowProps: (row, dataIndex, rowIndex) => ({
      style: {
        backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)' : 'white',
      },
    }),
    setTableProps: () => ({
      padding: 'default',
      border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
      size: 'small',
    }),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery !== null && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getTaskdata({ sortField, sortOrder, searchQuery });
        } else {
          getTaskdata({ searchQuery });
        }
        setLoading(true);
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const { sortField, sortOrder } = sortEnable;
          getTaskdata({ sortField, sortOrder });
        } else {
          getTaskdata('');
        }
        setLoading(true);
      }
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,

    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;
      const sortField = name;
      const sortOrder = direction;
      let searchQuery = searchEnable;
      let page_no = tableState.page;
      if (action === 'sort') {
        setSortEnable({ sortField, sortOrder });
        if (searchEnable) {
          getTaskdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getTaskdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
      setPage(tableState.page);
      if (action === 'changePage') {
        if (searchEnable) {
          getTaskdata({ sortField, sortOrder, searchQuery, page_no });
        } else {
          getTaskdata({ sortField, sortOrder, page_no });
        }
        setLoading(true);
      }
    },

    customTableBodyFooterRender: (opts) => (
      <>
        <TableFooter>
          <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, border: '1px solid #808080' }}>
            {opts.columns.map((col, index) => {
              if (col.name === 'dwr_number') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                    key={index}
                  >
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'task_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'job_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'client_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'quote_number') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'manager') {
                return <TableCell key={index}>{ }</TableCell>;
              }
              if (col.name === 'ratesheet') {
                return (
                  <TableCell
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                      textAlign: 'end',
                    }}
                    key={index}
                  >
                    Total :
                  </TableCell>
                );
              }
              if (col.name === 'estimated_cost') {
                return (
                  <TableCell
                    key={index}
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                  >
                    {estimatedCost.toFixed(2)}
                  </TableCell>
                );
              }
              if (col.name === 'dwrs_hours_cost') {
                return (
                  <TableCell
                    key={index}
                    sx={{
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: '18px',
                      border: '1px solid #808080 !important',
                    }}
                  >
                    {dwrCost.toFixed(2)}
                  </TableCell>
                );
              }
              if (col.name === 'status') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === 'active') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
              if (col.name === '') {
                return (
                  <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                    { }
                  </TableCell>
                );
              }
            })}
          </TableRow>
        </TableFooter>
      </>
    ),
  };

  const handleDuplicate = async (e, taskId, clientId, jobNumber) => {
    e.preventDefault();

    try {
      setLoading(true);

      const warnings = await validateBeforeDuplicate({
        clientId,
        jobNumber,
      });

      if (warnings.length > 0) {
        setAlertMessage(warnings.join('\n'));

        // 🔒 Save pending action
        setPendingDuplicate({ taskId });

        setAlertOpen(true);
        return; // ⛔ STOP here, wait for dialog action
      }

      // No warnings → duplicate directly
      await duplicateTask(taskId);
    } catch (error) {
      console.error('Error duplicating task:', error);
      toast.error('Failed to duplicate task');
    } finally {
      setLoading(false);
    }
  };

  const duplicateTask = async (taskId) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.DUPLICATE_TASK}${taskId}`);

      if (data?.statusCode === 200) {
        toast.success('Task duplicated successfully');

        const newTaskId = data?.task?._id || data?.taskId;
        if (newTaskId) {
          const managerUrl = `/manager/task/update/${newTaskId}`;
          navigate(managerUrl);
        }
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to duplicate task');
    }
  };

  const validateBeforeDuplicate = async ({ clientId, jobNumber }) => {
    let messages = [];

    if (clientId) {
      const clientRes = await authAxios.get(`${PRIVATE_ROUTE.GET_CLIENT_BY_ID}/${clientId}`);

      const client = clientRes?.data?.data[0];
      const clientTasks = client?.tasksdata || [];
      const clientInvoices = await fetchInvoicesforclient(clientId);

      if (clientTasks.length > 0) {
        messages.push(`${clientTasks.length} active task exist for this client.`);
      }

      if (clientInvoices.length > 0) {
        messages.push(`${clientInvoices.length} unpaid invoice exist for this client.`);
      }
    }

    if (jobNumber) {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE.GET_JOB_SEARCH}?search=${jobNumber}`);

      const job = data?.data?.[0];
      const jobTasks = job?.task || [];

      const taskIds = jobTasks.map((t) => t._id);
      const invoices = await fetchInvoices(taskIds);

      const activeTasks = jobTasks.filter((task) => task.is_completed === 0).length;

      const unpaidInvoices = invoices.filter((inv) => inv.is_paid === 0).length;

      if (activeTasks > 0) {
        messages.push(`${activeTasks} active task already exist for this job.`);
      }

      if (unpaidInvoices > 0) {
        messages.push(`${unpaidInvoices} unpaid invoice exist for this job.`);
      }
    }

    return messages;
  };

  const fetchInvoicesforclient = async (clientId) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.GET_INVOICES_BY_CLIENT}`, { client_id: clientId });
      return data.data || [];
    } catch (err) {
      console.error('Failed to fetch invoices:', err);
      return [];
    }
  };

  const fetchInvoices = async (taskIds) => {
    try {
      const { data } = await authAxios.post(`${PRIVATE_ROUTE.GET_INVOICES_BY_TASKS}`, { taskIds });
      return data.data || [];
    } catch (err) {
      console.error('Failed to fetch invoices:', err);
      return [];
    }
  };

  return (
    <>
      <Dialog open={alertOpen} onClose={() => setAlertOpen(false)}>
        <DialogTitle>⚠️ Confirmation Required</DialogTitle>

        <DialogContent>
          {alertMessage.split('\n').map((line, i) => (
            <p key={i} style={{ margin: '6px 0' }}>
              {line}
            </p>
          ))}
          <p style={{ marginTop: '12px', fontWeight: 500 }}>Do you still want to duplicate this task?</p>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setAlertOpen(false);
              setPendingDuplicate(null);
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              if (pendingDuplicate?.taskId) {
                duplicateTask(pendingDuplicate.taskId);
              }
              setAlertOpen(false);
              setPendingDuplicate(null);
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <TaskCompletionModal
        open={completionDialogOpen}
        onClose={() => {
          if (!completingTask) setCompletionDialogOpen(false);
        }}
        taskId={completionTaskId}
        jobNumber={completionJobNumber}
        taskNumber={completionTaskNumber}
        canComplete={completionCanComplete}
        unresolved={completionIssues}
        loading={false}
        error={completionError}
        onComplete={handleTaskComplete}
        completing={completingTask}
        title="Task Completion Validation"
      />
      <Grid sx={{ p: 4, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h4" gutterBottom>
            Active Task
          </Typography>
          <Button variant="contained" onClick={handlejobcreateform} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Task
          </Button>
        </Stack>
        <Grid container xs={8} spacing={2} sx={{ py: 2, alignItems: 'center' }}>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="manager-filter-label">Select Manager</InputLabel>

              <Select
                labelId="manager-filter-label"
                value={manageId}
                label="Select Manager"
                onChange={(e) => {
                  const selectedManager = e.target.value;

                  setManageId(selectedManager);
                  setPage(0);
                  setLoading(true);

                  getTaskdata({
                    sortField: sortEnable.sortField,
                    sortOrder: sortEnable.sortOrder,
                    searchQuery: searchEnable,
                    page_no: 0,
                    manageId: selectedManager,
                  });

                  getEstimatedBillableCost({
                    managerId: selectedManager,
                    startDate: selectedstartDate,
                    endDate: selectendDate,
                  });
                }}
              >
                <MenuItem value="All_Manager">All</MenuItem>

                <MenuItem value={state.user._id}>
                  {state.user.first_name} {state.user.last_name}
                </MenuItem>

              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={selectedstartDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectstartDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={selectendDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectendDate(formattedDate);
                }}
                renderInput={(props) => <TextField {...props} />}
                minDate={selectedstartDate}
                onError={(newError) => setIsValidDate(newError)}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={handleDateSort}
              disabled={selectendDate === null || selectedstartDate === null}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12} md="auto">
            <Button
              size="large"
              type="button"
              variant="outlined"
              onClick={handleClearDateSort}
              disabled={
                selectendDate === null &&
                selectedstartDate === null &&
                manageId === 'All_Manager'
              }
            >
              Reset
            </Button>
          </Grid>
        </Grid>
        <Grid>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <MUIDataTable options={options} columns={columns} data={tasks} />
                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}

                {!tasks && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>
    </>
  );
}
